import React from 'react';
import { getAllTopics } from '../data/debateTopics';
import './TopicSelector.css';

const TopicSelector = ({ currentTopic, onTopicChange }) => {
  const topics = getAllTopics();

  return (
    <div className="topic-selector">
      <label htmlFor="topic-select">Current Topic:</label>
      <select 
        id="topic-select"
        value={currentTopic} 
        onChange={(e) => onTopicChange(e.target.value)}
        className="topic-dropdown"
      >
        {topics.map((topic) => (
          <option key={topic.id} value={topic.id}>
            {topic.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TopicSelector;
